// eslint-disable-next-line import/prefer-default-export
export const PROVIDERS_API_BASE_ROUTE = '/api/providers';
